import React, { useState } from 'react';
import './index.scss';

const RadioGroup = (props) => {
  const onChange = (item) => {

  };

  return (
    <div className="radio-group-container">
      {
                (props.list || []).map((item) => {
                  return (
                    <div className="radio-item">{item.label}</div>
                  );
                })
            }
    </div>
  );
};
export default RadioGroup;
